<template>
    <div>
        <div class="row tt-item pr-lg-0">
            <div class="col-12 col-lg-4 tt-card">
                <div class="tt-title" v-if="timetable.about_link">
                    <a :href="timetable.about_link" target="_blank">{{ timetable.description }}</a>
                </div>
                <div class="tt-title" v-else>{{ timetable.name }}</div>
                <div class="tt-hard">
                    <img class="easy" :src="require(`@/assets/hometeacher/images/${difficlty}.png`)">
                </div>
                <div class="tt-subtitle">
                    <span class="tt-age"
                          v-if="timetable.min_age && timetable.max_age">
                        {{ timetable.min_age }}-{{timetable.max_age}}&nbsp;{{ agePlural(timetable.max_age) }},
                    </span>
                    <span class="tt-type" v-if="timetable.individual"> {{ $t('IndividualNBSPlessons') }}<span v-if="timetable.individualDetails && timetable.individualDetails.learningLanguageName">, {{ timetable.individualDetails.learningLanguageName }} язык</span></span>
                    <span class="tt-type" v-else> {{ $t('groupNBSPlessons') }}</span>

                </div>
                <div class="tt-description2">{{ timetable.description2 }}</div>
                <div class="tt-chat">
                    <a v-if="timetable.chat_link" target="_blank"
                       :title="$t('telegramm_link_title', {description: timetable.description})" rel="nofollow"
                       :href="timetable.chat_link">
                        <img src="@/assets/hometeacher/images/telegram.png">
                    </a>
                </div>
            </div>
            <div class="col-12 col-lg-4 pl-lg-0 pr-lg-0 tt-timetable-schedules">
                <TimetableSchedules :timetable="timetable" class="mt-3" @more="more"/>
            </div>
            <div class="col-12 col-lg-4 pl-lg-4">
                <SubscriptionsListCompact v-if="prolong" :timetable="timetable" :subscriptions="subscriptions"
                                          @back="prolong = false"
                                          @order="order"
                                          @bonusCourseClick="bonusCourseClick"/>
                <CrmSubscriptionsList v-if="!prolong" :crmSubscriptions="crmSubscriptions"
                                      @prolong="prolong = true"/>

                <div v-if="recurrent" @click.prevent="uncheckRecurrent">
                    <base-checkbox :checked="true" class="mt-4 custom-control-alternative danger">
                        {{ $t('reccurent_notice') }}
                    </base-checkbox>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import TimetableSchedules from "./TimetableSchedules";
    import SubscriptionsListCompact from "../../Subscriptions/SubscriptionsListCompact";
    import CrmSubscriptionsList from "./CrmSubscriptionsList";

    export default {
        name: 'TimetableItem',
        props: {
            timetable: {
                type: Object,
                required: true,
            },
            subscriptions: {
                type: Array,
                default: null,
                // required: true,
            },
            crmSubscriptions: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                prolong: false,
                confirmDialog: false,
                checkedRecurrent: true,
            }
        },

        computed: {
            difficlty() {
              if (this.timetable && this.timetable.difficulty) {
                if (this.timetable.difficulty.toLowerCase() === 'easy' || this.timetable.difficulty.toLowerCase() === 'low') return 'easy'
                if (this.timetable.difficulty.toLowerCase() === 'medium') return 'medium'
                if (this.timetable.difficulty.toLowerCase() === 'high' || this.timetable.difficulty.toLowerCase() === 'hard') return 'high'
              }
              return 'easy';
            },
            recurrent() {
                return this.timetable && this.timetable.lastUserSubscription && this.timetable.lastUserSubscription.fl_recurrent && Number(this.timetable.lastUserSubscription.fl_recurrent) === 1
            }
        },

        mounted() {

        },

        methods: {
            order(subscription, timetable) {
                this.$emit("order", subscription, timetable);
            },

            bonusCourseClick(subscription) {
                this.$emit("bonusCourseClick", subscription);
            },

            more(timetable) {
                this.$emit("more", timetable);
            },

            uncheckRecurrent() {
                this.checkedRecurrent = true
                this.$emit("uncheck-recurrent", this.timetable);
            },

            agePlural(age) {
                return this.plural([this.$t('year'), this.$t('years'), this.$t('years2')], age)
            },

            plural(forms, n) {
                let idx;
                // @see http://docs.translatehouse.org/projects/localization-guide/en/latest/l10n/pluralforms.html
                if (n % 10 === 1 && n % 100 !== 11) {
                    idx = 0; // many
                } else if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
                    idx = 1; // few
                } else {
                    idx = 2; // one
                }
                return forms[idx] || '';
            }

        },

        components: {
            CrmSubscriptionsList, SubscriptionsListCompact, TimetableSchedules
        }
    }
</script>

<style scoped>
    @media (max-width: 991.8px) {
        .tt-timetable-schedules {
            /*margin-left: -15px;
            margin-right: -15px;
            box-sizing: content-box;*/
            overflow-x: hidden;
        }

        .tt-item {
            border: none !important;
            box-shadow: 0px 6px 5px 0px #0000001c;
        }
    }

    @media (min-width: 992px) {
        .tt-timetable-schedules::before {
            content: " ";
            height: 100%;
            width: 1px;
            background: #d7e1e5;
            position: absolute;
            left: -20px;
        }

        .tt-card {
            padding-right: 50px;
        }
    }

    .tt-item {
        border: 1px solid #d7e1e5;
        border-radius: 5px;
        padding: 20px 20px;
    }

    .tt-title {
        font-size: 30px;
        line-height: 30px;
        color: #231c37;
        font-family: "Manrope Bold";
        margin-bottom: 5px;
    }

    .tt-title a {
        color: #231c37;
    }

    .tt-title a:hover {
        text-decoration: underline;
    }

    .tt-subtitle {
        font-size: 18px;
        line-height: 24px;
        color: #8b8496;
        font-family: "Manrope Bold";
        margin-top: 15px;
        margin-bottom: 20px;
    }

    .tt-description2 {
        color: #4f4d5c;
        font-size: 16px;
        line-height: 18px;
    }
</style>
